"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
/**
 * Returns formatted FAQ info
 * @param {object} faq
 * @returns {FaqFactoryType}
 */
function faqFactory(faq) {
    return {
        answer: (0, get_1.default)(faq, 'answer', ''),
        question: (0, get_1.default)(faq, 'question', ''),
    };
}
exports.default = faqFactory;
